module.exports = __webpack_public_path__ + "img/powered-by.eb5e0b5c.png";